import request from '@/libs/http/index'

// 收费设置---------
// 收费设置
export const chargeSettingsDetail = params => {
  return request.get({
    url: `/clinic/settings-charge/get`,
    params,
  })
}
export const chargeSettingsUpdate = data => {
  return request.put({
    url: `/clinic/settings-charge/update`,
    data,
  })
}
export const chargeSettingsDefault = params => {
  return request.get({
    url: `/clinic/settings-charge/restore-default`,
    params,
  })
}

// 附加费---------
// 附加费
export const extraChargePage = params => {
  return request.get({
    url: `/clinic/settings-extra-charge/page`,
    params,
  })
}
export const extraChargeCreate = data => {
  return request.post({
    url: `/clinic/settings-extra-charge/create`,
    data,
  })
}
export const extraChargeUpdate = data => {
  return request.put({
    url: `/clinic/settings-extra-charge/update`,
    data,
  })
}
export const extraChargeDelete = data => {
  return request.delete({
    url: `/clinic/settings-extra-charge/delete?id=${data}`,
  })
}
